export default __webpack_public_path__ + "static/media/GSK_CMYK_2013.1794f32d.png";